const consentKey = "desu-analytics-consent";

function trySet(qs, key, setter) {
  try {
    let value = setter();
    if (value) {
      value = String(value).trim();
      if (value) qs.set(key, value);
    }
  } catch (e) {}
}

function sendPixelRequest(extra = {}) {
  const qs = new URLSearchParams();
  for (const key in extra) {
    if (extra[key]) qs.set(key, extra[key]);
  }
  trySet(qs, "or", () => window.screen.orientation.type);
  trySet(qs, "pl", () => navigator.userAgentData.platform);
  trySet(qs, "pm", () => (navigator.userAgentData.mobile ? "1" : null));
  trySet(qs, "pr", () => window.devicePixelRatio);
  trySet(qs, "rs", () => `${window.screen.width}x${window.screen.height}`);
  trySet(qs, "v", () => "1");
  trySet(qs, "ws", () => `${window.innerWidth}x${window.innerHeight}`);
  const url = `/static/uwu.gif?${qs.toString()}`;
  void fetch(url, { method: "GET", mode: "no-cors", credentials: "omit" });
}

function setAnalyticsConsent(consent) {
  const data = JSON.stringify({ consent, time: Math.round(+new Date()) });
  localStorage.setItem(consentKey, data);
}

function getAnalyticsConsentInfo() {
  try {
    const val = localStorage.getItem(consentKey);
    return val === null ? null : JSON.parse(val);
  } catch (e) {
    // If `localStorage` is disabled, we assume no consent.
    return { consent: false };
  }
}

function fadeBoxIn(div) {
  div.hidden = false;
  div.animate(
    [
      { opacity: 0, transform: "translateY(10px)" },
      { opacity: 1, transform: "translateY(0)" },
    ],
    { duration: 300, easing: "ease-out" },
  );
}

function fadeBoxOut(div) {
  div.animate(
    [
      { opacity: 1, transform: "translateY(0)" },
      { opacity: 0, transform: "translateY(-10px)" },
    ],
    { duration: 300, easing: "ease-out" },
  );
  setTimeout(() => (div.hidden = true), 300);
}

function userVehementlyDeniesTracking() {
  try {
    if (
      window.navigator.doNotTrack === "1" ||
      window.navigator.doNotTrack === "yes"
    ) {
      return true;
    }
  } catch (e) {
    // Ignore, property might not be available.
  }
  try {
    if (window.navigator.globalPrivacyControl === true) {
      return true;
    }
  } catch (e) {
    // Ignore, property might not be available.
  }
  return false;
}

async function showConsentBoxIfNeeded() {
  const consentBoxWrapper = document.getElementById(
    "analytics-consent-wrapper",
  );
  if (!consentBoxWrapper) {
    // No consent box wrapper found on this page.
    return;
  }
  if (getAnalyticsConsentInfo() !== null) {
    // The user has already given or denied consent.
    return;
  }
  if (userVehementlyDeniesTracking()) {
    return;
  }
  const imageUrl = consentBoxWrapper.dataset.imgSource;
  const res = await fetch(imageUrl);
  if (!res.ok) {
    return;
  }
  consentBoxWrapper.innerHTML = await res.text();
  document.getElementById("analytics-consent-button-yes").addEventListener(
    "click",
    () => {
      fadeBoxOut(consentBoxWrapper);
      setAnalyticsConsent(true);
      sendPixelRequest({ init: 1 });
    },
    false,
  );
  document.getElementById("analytics-consent-button-no").addEventListener(
    "click",
    () => {
      fadeBoxOut(consentBoxWrapper);
      setAnalyticsConsent(false);
    },
    false,
  );
  fadeBoxIn(consentBoxWrapper);
}

export function setup() {
  setTimeout(() => showConsentBoxIfNeeded(), 500);
  if (Math.random() < 0.3) {
    const consentInfo = getAnalyticsConsentInfo();
    if (consentInfo?.consent) {
      // Send a pixel request with a 30% chance, if we have consent.
      setTimeout(() => sendPixelRequest({ ctm: consentInfo?.time }), 5000);
    }
  }
}
